import { render, staticRenderFns } from "./BerthInsertData.vue?vue&type=template&id=b20a8d1c&scoped=true&"
import script from "./BerthInsertData.vue?vue&type=script&lang=js&"
export * from "./BerthInsertData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20a8d1c",
  null
  
)

export default component.exports